import Component from "@glimmer/component";
import { task } from "ember-concurrency";
import { service } from "@ember/service";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import server from "glesys-controlpanel/models/server";
import { instanceOf } from "prop-types";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

@forbidExtraArgs
export default class ServerConfigurationKvm extends Component {
  @service abilities;
  @service store;

  @arg(instanceOf(server)) server;

  get isEditable() {
    return this.abilities.can("reconfigure for server", this.server);
  }

  updateServerDetails = task(async (type, oldValue, newValue) => {
    let config = {},
      server = this.server;
    config[type] = newValue;
    for (let [key, value] of Object.entries(config)) {
      server.set(key, value);
    }
    await this.store.request(saveRecord(server));
  });
}
